import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import DailyChartGrid from "../../Common/DailyChartGrid";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import i18next from "i18next";

class SubSchedule extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedTabNum: null
        };
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.listSubForPO.reset());
            await this.props.dispatch(this.props.monthList.reset());
            await this.props.dispatch(this.props.yearList.reset());

            await this.props.dispatch(this.props.listSubForPO.execute({}, {withParams: true}));
        } catch (e) {
            console.error(e);
        }
    }

    renderParam = (h) => {
        return (<>
            <div className="row mb-2">
                <div className="col-md-4">
                    {/*Количество уровней подчиненности (<span style={{color: "red"}}>не более 5 уровней</span>):*/}
                    {h.lbl("NumSub")}
                </div>
                <div className="col-md-1">
                    {h.ed("NumSub")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-12">
                    {h.ed("AdmStructName")}
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-4">
                    {i18next.t("SubordinateSearch")}:
                </div>
                <div className="col-md-8" style={{height: "32px"}}>
                    <SearchBar dataItem={this.props.listSubForPO}
                               afterApplyValue={this.afterApplyFilter}
                    />
                </div>
            </div>

            <div className="row mb-2">
                <div className="col-md-1">
                    {h.lbl("NumYear")}
                </div>
                <div className="col-md-1">
                    {h.ed("NumYear")}
                </div>
                <div className="col-md-1">
                    {h.lbl("MonthView")}
                </div>
                <div className="col-md-2">
                    {h.ed("MonthView")}
                </div>
            </div>
        </>);
    };

    onSelectPerson = (rowIndex, row, e) => {
        this.getPersonData(row.TabNum);
        this.setState({selectedTabNum: row.TabNum});
    };

    getPersonData = async (tabNum, updateOnlyMonth) => {
        if (!tabNum) {
            return;
        }

        if (this.props.listSubForPOParams.isInitialized) {
            let params = {
                ...this.props.listSubForPOParams.getRow(0), SubTabNum: tabNum
            };
            try {
                await this.props.dispatch(this.props.monthList.execute(params, {withStyle: true}));
                if (!updateOnlyMonth) {
                    await this.props.dispatch(this.props.yearList.execute(params, {withStyle: true}));
                }
            } catch (e) {
                console.log(e);
            }
        }
    };

    gridRowStyleProvider = (rowIndex, row) => {
        if (this.state.selectedTabNum && this.state.selectedTabNum === row.TabNum) {
            return {fontWeight: "bold", backgroundColor: "lightgrey"};
        }
        return {};
    };

    paramsEndFieldUpdate = async (rowIndex, fieldDescriptor) => {
        if (fieldDescriptor.Name === "NumYear") {
            this.getPersonData(this.state.selectedTabNum);
        } else if (fieldDescriptor.Name === "MonthView") {
            this.getPersonData(this.state.selectedTabNum, true);
        } else {
            await this.props.dispatch(this.props.listSubForPO.applyParams(this.props.listSubForPOParams));
            this.afterApplyFilter();
        }
    };

    afterApplyFilter = () => {
        if (this.props.listSubForPO.isInitialized && this.state.selectedTabNum && !this.props.listSubForPO.dataTable().some(r => r.TabNum === this.state.selectedTabNum)) {
            this.setState({selectedTabNum: null});
        }
    };

    render() {
        let monthChartTitle = <></>;
        let yearChartTitle = <></>;
        if (this.state.selectedTabNum && this.props.listSubForPOParams.isInitialized) {
            let selectedPerson = this.props.listSubForPO.dataTable().filter(r => r.TabNum === this.state.selectedTabNum);
            if (selectedPerson.length === 1) {
                selectedPerson = selectedPerson[0];

                let params = this.props.listSubForPOParams.getRow(0);

                monthChartTitle = <> {i18next.t("SubSchedule_MonthSchedulePlaceholder", {
                    month: params.MonthView,
                    year: params.NumYear.toString()
                })} [<span style={{color: "red"}}>{selectedPerson.FIO}</span>]</>;
                yearChartTitle = <> {i18next.t("SubSchedule_YearSchedulePlaceholder", {year: params.NumYear.toString()})} [<span
                    style={{color: "red"}}>{selectedPerson.FIO}</span>]</>;
            }
        }

        let cnt = this.props.listSubForPO.rowsCount();
        let gridTitleText = i18next.t("SubordinateList_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (<>
            <h2>{i18next.t("SubSchedule_Title")}</h2>
            <PlaceholderWrapper placeholderId="SubSchedule_20"
                                title={<><i className='fa fa-filter'/> {i18next.t('Filters')}</>}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <ComplexParam dataItem={this.props.listSubForPOParams}
                              readOnly={false}
                              showSearchBar={false}
                              showApplyButton={false}
                              autoApplyParams={false}
                              rootPath="/"
                              parentDataItem={this.props.listSubForPO}
                              renderParams={this.renderParam}
                              onEndEditField={this.paramsEndFieldUpdate}
                />
            </PlaceholderWrapper>

            <PlaceholderWrapper placeholderId="SubSchedule_30"
                                title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                staticTitle={i18next.t("SubordinateList_GridTitle")}
                                showSplitterLine={false}
                                canCollapse={false}
            >
                <GridView dataItem={this.props.listSubForPO}
                          onRowClick={this.onSelectPerson}
                          updateStateFlag={{tabNum: this.state.selectedTabNum}}
                          rowStyleProvider={this.gridRowStyleProvider}
                />
            </PlaceholderWrapper>

            {this.state.selectedTabNum && <>
                <PlaceholderWrapper placeholderId="40"
                                    title={<><i className='fa fa-table'/>{monthChartTitle}</>}
                                    staticTitle={`${i18next.t('Schedule')} ${i18next.t('For_Period')} - 40`}
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    <DailyChartGrid dataItem={this.props.monthList}/>
                </PlaceholderWrapper>
                <PlaceholderWrapper placeholderId="50"
                                    title={<><i className='fa fa-table'/>{yearChartTitle}</>}
                                    staticTitle={`${i18next.t('Schedule')} ${i18next.t('For_Period')} - 50`}
                                    showSplitterLine={false}
                                    canCollapse={false}>
                    <DailyChartGrid placeholderId="50"
                                    title={yearChartTitle}
                                    dataItem={this.props.yearList}
                    />
                </PlaceholderWrapper>
            </>}
        </>);
    }
}

SubSchedule.propTypes = {
    dispatch: PropTypes.func.isRequired,
    listSubForPO: PropTypes.object,
    listSubForPOParams: PropTypes.object,
    monthList: PropTypes.object,
    yearList: PropTypes.object
};

SubSchedule.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        listSubForPO: state.subScheduleState.SubSchedule_ListSubForPO,
        listSubForPOParams: state.subScheduleState.SubSchedule_ListSubForPOParams,
        monthList: state.subScheduleState.SubSchedule_MonthList,
        yearList: state.subScheduleState.SubSchedule_YearList
    }
}

export default connect(mapStateToProps)(SubSchedule);